<div
    #chartElementRef
    class="agpr-topEntitiesChartBlock agpr-contextMenu-parent"
>
    @if (!preview) {
        <div class="agpr-topEntitiesChartBlock-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                [id]="id + '_export'"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'json', 'csv', 'print' ]"
                (exportMenuClicked)="exportChart($event, chartElementRef)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
    }

    @if (preview && series) {
        <div class="agpr-chartBlock-watermark">
            {{ 'Reports.chart.sampleData' | localize }}
        </div>
    }

    @if (renderable || !shouldValidateSeries) {
        @if (displayElement && series) {
            <agpr-top-entities-drill-down-chart
                #topEntitiesChart
                [id]="id + '_topEntitiesChart'"
                [displayElement]="displayElement"
                [series]="series"
                [preview]="preview"
                [entityType]="block.type?.key === reportBlockTypes.TOP_10_OUTLETS ? entityTypes.OUTLET : entityTypes.CONTACT"
                [metricSelectable]="metricSelectable"
                [bigProfileImage]="bigProfileImage"
                [height]="height"
                [titleAndMetadataHeight]="preview ? 220 : 280"
                [canViewProfileDetail]="canViewProfileDetail && !preview"
                (seriesChange)="seriesChange.emit($event)"
            ></agpr-top-entities-drill-down-chart>
        }
    } @else {
        <div class='agpr-chartBlock-placeholder'>
            <div class="agpr-chartBlock-placeholder-topRow">
              <span class="fa agpr-chartBlock-placeholderIcon {{ block.type.icon }}" aria-hidden="true"></span>
              <span class="agpr-chartBlock-placeholderLabel">{{ block.type.label | localize }}</span>
            </div>
            <div class="agpr-chartBlock-noChartMessage">
                @if (preview) {
                    <agpr-message
                        [id]="id + '_placeholder_preview_dataSource_info'"
                        [severity]="messageSeverities.info"
                    >
                        {{ 'Reports.chart.noDataSource' | localize }}
                    </agpr-message>
                } @else {
                    <agpr-message
                        [id]="id + '_placeholder_dataSource_error'"
                        [severity]="messageSeverities.error"
                    >
                        {{ 'Reports.error.folderRemoved' | localize }}
                    </agpr-message>
                    }
            </div>
        </div>
    }
</div>
